import { z } from 'zod'

export const ReceivableAvailabilitySchema = z.object({
  date: z.string().nullable(),
  status: z.enum(['unknown', 'pending', 'available', 'commercial']),
  source: z.enum(['unavailable', 'charge', 'connected_account', 'commercial']),
  cardCountry: z.string().nullable(),
  observedAt: z.string().nullable().optional(),
})

export function availabilityLabel(value: unknown, date?: string): string {
  const parsed = ReceivableAvailabilitySchema.safeParse(value)
  if (parsed.success && parsed.data.status === 'available')
    return 'Disponibilidade confirmada na conta de pagamento'
  return date ? `Liberação prevista: ${date}` : 'Aguardando previsão de liberação'
}
